import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { CustomerService } from 'src/app/angularJS/services/customer/customer.service';
import { BreadcrumbService } from 'src/app/angularJS/services/breadcrumbs/breadcrumb.service';
import { ChargeAccountBaseComponent } from '../charge-account-base.component';
import { UserService } from 'src/app/angularJS/services/user/user.service';

export class ChargeAccountStatementController extends ChargeAccountBaseComponent {

  public static $inject = [
    'breadcrumbService',
    'chargeAccount',
    'customerService',
    'userService',
    '$state',
    'ACTToolbarService',
    '$translate'
  ];

  constructor(
    public breadcrumbService: BreadcrumbService,
    public chargeAccount: InterACT.Interfaces.ChargeAccounts.ChargeAccount,
    public customerService: CustomerService,
    public userService: UserService,
    public $state: ng.ui.IStateService,
    public ACTToolbarService: ACTToolbarService,
    public $translate: ng.translate.ITranslateService) {
    super(chargeAccount, breadcrumbService, customerService, ACTToolbarService, userService, $state, $translate);
    this.activate();
  }

  private activate() {
    this.setToolbarAndBreadcrumbs('charge-account-statement');
  }
}
